// This service fetches environment variables from the server or client context

type ContextVars = Record<string, string | undefined> | null

let cachedContextVars: Promise<ContextVars> | null = null
const fetchContextVarsFromApi = async (): Promise<ContextVars> => {
	if (cachedContextVars) {
		// If the cache is already populated, return the existing promise
		return cachedContextVars
	}
	// If the cache is not populated, fetch the context variables from the API
	cachedContextVars = fetch(`/api/context`).then(async response => {
		const value = await response.json()
		if (response.status !== 200) {
			console.error(`Failed to fetch context variables from api: ${value.error}`)
			return null
		}
		return value
	})
	return cachedContextVars
}

export const getEnvVariable = async (name: string): Promise<string | null> => {
	const isServer = typeof window === 'undefined'
	if (isServer) {
		// Code that runs only on the server
		return process.env[name] ?? null
	}
	// Code that runs only on the client
	const contextVars = await fetchContextVarsFromApi()

	if (contextVars === null) {
		console.error(
			`getEnvVariable [${name}] - Failed to fetch context variables`
		)
		return null
	}
	// Return the environment variable value
	return contextVars[name] ?? null
}
